/// <amd-module name="Feed/CreateFeed/Redux/CreateFeed/CreateFeedContracts" />
import { Identity } from "VSS/Platform/Contracts/Identities";
import { IVSSPageDataAwareState } from "VSS/Redux/Modules/VSSPageData";

import { UpstreamSource } from "Feed/Common/Contracts/Feed";
import { ICreateFeedData } from "Feed/CreateFeed/Types";
import { ITfsPageDataAwareState } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts";

export interface ICreateFeedOwnState {
    createFeedState: ICreateFeedState;
}

export interface ICreateFeedAwareState extends ICreateFeedOwnState, ITfsPageDataAwareState, IVSSPageDataAwareState {}

export interface ICreateFeedState extends ICreateFeedData {
    errorMessage: string | undefined;
    isSaving: boolean;
}

export class Visibility {
    public static aadTenant = "aadTenant";
    public static collection = "collection";
    public static private = "private";
    public static public = "public";
    public static project = "project";
}

export interface ICreateFeedSettings {
    projectId?: string; // if set, the feed will be project scoped
    identityGroups: Identity[];

    feedName: string;
    visibility: string;
    upstreamSources?: UpstreamSource[];
}
